import { render, staticRenderFns } from "./IconCodeSolid.vue?vue&type=template&id=0406240d"
import script from "./IconCodeSolid.vue?vue&type=script&lang=js"
export * from "./IconCodeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports